const checkAccessFn = (dashboardData, module, name) => {
  if (!dashboardData?.data?.user_permissions || !dashboardData?.data?.permissions) {
    return false;
  }

  const userHasPermission = dashboardData.data.user_permissions.some(
    (perm) => perm.name?.trim() === name?.trim() && perm.module?.trim() === module?.trim()
  );

  const modulePermissionExists = dashboardData.data.permissions.some(
    (perm) => perm.name?.trim() === name?.trim() && perm.module?.trim() === module?.trim()
  );

  return userHasPermission && modulePermissionExists;
};

export { checkAccessFn };
